export default "__VITE_ASSET__BEsx$1La__"